import { getOrgConfig } from '@api/organization';
import { getOrganizationIdFromStorage } from '@components/containers/procurementOrders/formComponents';
import { useQuery } from '@tanstack/react-query';

export type BundleView = 'byProduct' | 'asSold';

/**
 * Whether this brand gets the Sales page bundle views (By product / As sold), and which one
 * the page opens on. Off for every brand until its `salesViewDefaults.bundleReporting` is set,
 * so they see exactly the Sales page they have now. Same query key as the other org-config
 * readers, so it shares their fetch.
 */
export function useBundleReporting(): { enabled: boolean; defaultView: BundleView } {
    const organizationId = getOrganizationIdFromStorage();
    const { data } = useQuery(
        ['org-config', organizationId],
        () => getOrgConfig(organizationId as string),
        { enabled: !!organizationId, staleTime: 5 * 60_000 },
    );
    const setting = data?.salesViewDefaults?.bundleReporting;
    return {
        enabled: setting?.enabled === true,
        defaultView: setting?.defaultView === 'asSold' ? 'asSold' : 'byProduct',
    };
}
